















import { Component, Prop, Emit, Vue } from 'vue-property-decorator'
import { Getter, Action, namespace } from 'vuex-class'
import { TinyColor } from '@ctrl/tinycolor'

import Color from '@/models/color'

import Tooltip from 'primevue/tooltip'

Vue.directive('tooltip', Tooltip)

const App = namespace('app')

@Component
export default class ColorBadge extends Vue {
  @Prop() value!: string
  @Prop() icon!: string
  @Prop() colorCode!: string
  @Prop() tooltipContent!: string
  @Prop({ default: () => { return false } }) useLightBadges!: boolean

  @App.Getter('colors') colors!: Color[]
  @App.Action('colors') loadColors!: Function

  async mounted () {
    if (!this.colors || this.colors.length === 0) {
      this.loadColors()
    }
  }

  get resolvedColor () {
    const code = this.colorCode || 'E6E6E6'
    const matchingColors = this.colors.filter(color => {
      return color.code === code
    })
    return matchingColors.length > 0 ? matchingColors[0] : new Color({ code: code })
  }

  get actsAsButton () {
    return !!this.icon
  }

  get style () {
    if (!this.colorCode) return 'background-color: #' + this.resolvedColor.code
    const color = new TinyColor(this.resolvedColor.code)

    let bgColor = color.toString()
    let textColor = 'white'
    if (this.useLightBadges) {
      const darkenAmount = Number(this.resolvedColor?.meta?.darkenBy)
      const lightenAmount = Number(this.resolvedColor?.meta?.lightenBy)
      bgColor = lightenAmount && this.value ? color.lighten(lightenAmount).toString() : color.toString()
      textColor = darkenAmount ? color.darken(darkenAmount).toString() : color.toString()
    }

    let styleString = ''
    styleString += 'background-color: ' + bgColor + ';'
    styleString += 'color: ' + textColor + ';'

    return styleString
  }

  @Emit()
  click () {
    return true
  }
}
